import React from "react";
import { Outlet } from "react-router-dom";
import Layout from "../../layout/Layout";

const WhatsAppNumber = () => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default WhatsAppNumber;
